export const PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [5, 10, 20];
export const AVATAR_MAX_SIZE = 300;
export const USER_ROLES = {
  User: "User",
  Supervisor: "Supervisor",
};
